import React, { Component } from 'react'
import { Title } from '../../../components/layout'
import { routerAdapter } from '../../../helpers/decorators'
import styles from './forbidden.styl'

@routerAdapter()
class Forbidden extends Component {
    static propTypes = {
    }

    static defaultProps = {}

    render() {
        return (
            <div className={styles.wrapper}>
                <Title h2 intlKey="moduleTitle.forbidden">
                    Forbidden
                </Title>
                <class className={`${`ico ico--sad`} ${styles.large}`} /> <br />
            </div>
        )
    }
}

export default Forbidden
